<template>
  <div class="cyber">
    <v-container fluid
                 class="pa-0">
      <v-row no-gutters class="flex-nowrap">

        <v-col cols="6">

          <v-checkbox v-model="cyberselected"
                      color="primary"
                      hide-details
                      class="pa-0">

            <template slot="label">

                          <span class="mylabel enabled--text mr-1">
                            Cyber-Rechtsschutz
                          </span>

              <site-tooltip titel="Cyber-Rechtsschutz">
                Der Cyber-Rechtsschutz schützt umfassend gegen Gefahren aus der privaten Internetnutzung: Durch leistungsstarke rechtliche Hilfe und wertvolle Serviceleistungen wie der psychologischen Soforthilfe nach Cyber-Mobbing und vorbeugende Maßnahmen zum Schutz gegen Missbrauch persönlicher Daten.
              </site-tooltip>

            </template>

          </v-checkbox>

        </v-col>

        <v-col cols="6">
          <v-row no-gutters>

            <v-col cols="6"
                    class="zusatz--column">
              <div :class="cyberselected ? 'selected--text' : 'enabled--text'">
                {{ cybersb.slice(2) }}&nbsp;€
              </div>
            </v-col>

            <v-col cols="6"
                    class="zusatz--column">
              <div :class="cyberselected ? 'selected--text' : 'enabled--text'">
                {{ $helpers.toGermanFloatString(cyberPraemie) }}&nbsp;€
              </div>
            </v-col>

          </v-row>
        </v-col>

      </v-row>
    </v-container>
  </div>
</template>

<script>
import KeyTranslator from "@/components/helper/keyTranslatorMixin";
import ValidationMixin from "@/components/helper/ValidationMixin";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";

export default {
  mixins: [twowayBinding, ValidationMixin, KeyTranslator],
  computed: {
    ...mapTwoWay([
      "cyberselected",
      "cybersb",
      "productLine",
      "family",
      "civilServant",
      "contractlength",
      "zahlweise"]),
    cyberPraemie() {
      return this.$store.getters.singlePraemie(
        "Cyber",
        this.productLine,
        this.family,
        this.beamterBoolToKey(this.civilServant),
        this.cybersb,
        this.contractlength,
        this.zahlweise,
        this.$store.getters.rabatt(this.statePath)
      );
    }
  },
};
</script>

<style>
.cyber .icon {
  cursor: pointer;
}

.cyber .selected--text {
  color: #0085CF;
  font-size: 16px;
}

.cyber .enabled--text {
  font-size: 16px;
}

.cyber .mylabel {
  font-size: 16px;
}

.cyber .input-group__details {
  display: none !important;
}

.cyber .checkbox > label {
  min-width: 100% !important;
  width: 100% !important;
}
</style>


